<template>
  <v-layout fluid row wrap>
    <v-flex sm3>
      <h2 class="headline">For company</h2>
      <v-form>
        <v-checkbox
          label="Show winners"
          v-model="formData.isShowWinners"
        ></v-checkbox>
        <v-btn class="green white--text" @click="submitUpdate">submit</v-btn>
      </v-form>
    </v-flex>
    <v-flex sm3>
      <h2 class="headline">For individual</h2>
      <v-form>
        <v-checkbox
          label="Show winners"
          v-model="formDataIndividual.isShowWinners"
        ></v-checkbox>
        <v-btn class="green white--text" @click="submitIndividualUpdate">submit</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { path } from 'ramda'
  export default {
    name: 'AwardsSettingsWinners',
    data () {
      return {
        formData: {},
        formDataIndividual: {}
      }
    },
    computed: {
      ...mapGetters(['getSettings'])
    },
    methods: {
      ...mapActions({
        fetchSettings: 'fetchGeneralSettings',
        updateSettings: 'putAwardsSettingsWinners',
        updateIndividualSettings: 'putAwardsSettingsIndividualWinners'
      }),
      submitUpdate () {
        this.updateSettings({isShowWinners: this.formData.isShowWinners})
      },
      submitIndividualUpdate () {
        this.updateIndividualSettings({isShowWinners: this.formDataIndividual.isShowWinners})
      }
    },
    async mounted () {
      if (!this.getSettings) {
        await this.fetchSettings()
      }
      this.formData = path(['awardsSetting'], this.getSettings)
      this.formDataIndividual = path(['awardsIndividualSettings'], this.getSettings)
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Awards/Settings/Winners/index.vue